import { Record } from 'immutable';
import * as Actions from './constants';
import RecoverStep from '../enums/recoverStep';
import RecoverType from '../enums/recoverType';
import ErrorCode from '../enums/textErrorCode';
var InitialState = Record({
  apiUrl: '',
  phoneNumberFormat: /([0-9]{10})/,
  captchaApiKey: '',
  captchaLanguage: '',
  captchaToken: '',
  recoverStep: RecoverStep.RECOVER_CHOICE,
  recoverType: '',
  recoverCode: '',
  recoverToken: '',
  attemptCount: 0,
  isLoading: false,
  errorCode: '',
  recipient: '',
  fieldsProps: {}
});
var initialState = new InitialState();
/**
 * Password recovery redux reducer
 * @param  {Object} inputState  App state
 * @param  {Object} action      Action
 * @returns {Object} new copy of state with updated values
 */

export function passwordRecoverReducer() {
  var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case Actions.SET_INITIAL_STATE:
      return inputState.merge(action.payload.state);
    case Actions.USER_RESET_RECOVER:
      return inputState.merge({
        recoverStep: RecoverStep.RECOVER_CHOICE,
        recoverType: ''
      });
    case Actions.USER_CHOOSE_PHONE_RECOVER:
      return inputState.merge({
        recoverStep: RecoverStep.ENTER_DATA_FOR_RECOVER,
        recoverType: RecoverType.PHONE_RECOVER
      });
    case Actions.USER_CHOOSE_EMAIL_RECOVER:
      return inputState.merge({
        recoverStep: RecoverStep.ENTER_DATA_FOR_RECOVER,
        recoverType: RecoverType.EMAIL_RECOVER
      });
    case Actions.CHECK_RECOVERY_CODE_VALIDITY_FETCH:
      return inputState.merge({
        isLoading: true
      });
    case Actions.CHECK_RECOVERY_CODE_VALIDITY_SUCCESS:
      return inputState.merge({
        recoverStep: RecoverStep.ENTER_NEW_PASSWORD,
        recoverToken: action.payload.recoverToken,
        attemptCount: action.payload.attemptCount,
        isLoading: false
      });
    case Actions.CHECK_RECOVERY_CODE_VALIDITY_EXPIRED_OR_INVALID:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVERY_CODE_INVALID_OR_EXPIRED,
        isLoading: false
      });
    case Actions.CHECK_RECOVERY_CODE_VALIDITY_ERROR:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVERY_CODE_ERROR,
        isLoading: false
      });
    case Actions.SAVE_PASSWORD_FETCH:
      return inputState.merge({
        isLoading: true
      });
    case Actions.SAVE_PASSWORD_SUCCESS:
      return inputState.merge({
        recoverStep: RecoverStep.NEW_PASSWORD_SAVED,
        isLoading: false
      });
    case Actions.SAVE_PASSWORD_ERROR:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.SAVE_PASSWORD_ERROR,
        isLoading: false
      });
    case Actions.SET_CAPTCHA_TOKEN:
      return inputState.merge({
        captchaToken: action.payload
      });
    case Actions.RECOVER_BY_EMAIL_FETCH:
      return inputState.merge({
        isLoading: true,
        recipient: action.payload.email
      });
    case Actions.RECOVER_BY_EMAIL_SUCCESS:
      return inputState.merge({
        recoverStep: RecoverStep.EMAIL_SENT_INFO,
        recoverToken: action.payload.recoverToken,
        attemptCount: action.payload.attemptCount,
        recipient: action.payload.email,
        isLoading: false
      });
    case Actions.RECOVER_BY_EMAIL_ERROR:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVER_BY_EMAIL_ERROR,
        isLoading: false
      });
    case Actions.RECOVER_BY_EMAIL_INVALID:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVER_BY_EMAIL_INVALID,
        isLoading: false
      });
    case Actions.RECOVER_BY_PHONE_FETCH:
      return inputState.merge({
        isLoading: true,
        recipient: action.payload.phoneNumber
      });
    case Actions.RECOVER_BY_PHONE_SUCCESS:
      return inputState.merge({
        recoverStep: RecoverStep.CHECK_ENTERED_RECOVER_DATA,
        recoverToken: action.payload.recoverToken,
        attemptCount: action.payload.attemptCount,
        recipient: action.payload.phoneNumber,
        isLoading: false
      });
    case Actions.RECOVER_BY_PHONE_ERROR:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVER_BY_PHONE_ERROR,
        isLoading: false
      });
    case Actions.RECOVER_BY_PHONE_INVALID:
      return inputState.merge({
        recoverStep: RecoverStep.USER_ERROR,
        errorCode: ErrorCode.RECOVER_BY_PHONE_INVALID,
        isLoading: false
      });
    case Actions.USER_LOCKDOWN:
      return inputState.merge({
        recoverStep: RecoverStep.USER_LOCKDOWN,
        isLoading: false
      });
    default:
      return inputState;
  }
}